// Add operation on an open work order: addOperation (a new op's row under its work order) and
// the Add operation modal (op code picker, Schedule it now, the running list of the WO's ops).
// Moved out of app.js unchanged (docs/split-plan.md, session 7b).
import { codeSearch, processOpCodes } from './opCodePicker';
import { mountScheduleAssist } from './scheduleAssist';
import { escapeHTML, getDB, woLabel } from './utilities';
import { operationSeverity } from './wo-ops-aggregation';
import { addJob, setPendingOpSchedule } from './woForm';
import { OP_ROW_PILL_LABEL, OP_ROW_PILL_TONE } from './woTable';

let shell = null;
export function setAddOperationDeps(deps) { shell = deps; }

export async function addOperation(info) {
  document.getElementById('activeJobs').innerHTML = '';
  let rowData = null;
  let allRows = null;

  if (Array.isArray(info) && info.length > 0) {
    rowData = info[0];
    allRows = info;
}else{
    rowData = JSON.parse(document.getElementById('operations-table').querySelector('.op-table-data-row').getAttribute('data-jobInfo'));
    allRows = document.getElementById('operations-table').querySelectorAll('.op-table-data-row');
}

  const storage = document.getElementById('winter-storage-section')
  const winterSpring = document.getElementById('storage-work-order-section')
  const dates = document.getElementById('work-order-date-section')
  const general = document.getElementById('general-work-order-section')

  storage.classList.add('hidden-form-section');
  dates.classList.add('hidden-form-section');
  winterSpring.classList.add('hidden-form-section')
  winterSpring.style.display='none';
  general.classList.remove('hidden-form-section');
  general.style.display='flex';

  document.getElementById('general-work-order-button').style.display = 'none';
  document.getElementById('customerDatabaseButton').style.display = 'none';
  document.querySelector('.work-order-type').style.display = 'none';

  const workOrderNumber = rowData.Work_Order;

  const currentOpCodes = [];

for (let row of allRows) {
    let info;

    // Check if row is a DOM element with `getAttribute`
    if (row instanceof Element && typeof row.getAttribute === 'function') {
        let data = row.getAttribute('data-jobinfo');

        try {
            info = typeof data === 'string' ? JSON.parse(data) : data;
        } catch (e) {
            console.error('Invalid JSON in data-jobinfo:', data);
            continue; // Skip this row if JSON parsing fails
        }
    } else if (typeof row === 'object' && row !== null) {
        // Assume row is already a parsed object if it's not a DOM element
        info = row;
    }

    // Ensure info is an object and has an OpCode property
    if (info && typeof info === 'object' && info.OpCode) {
        currentOpCodes.push(info.OpCode);
    }
}



  console.log(currentOpCodes);

  document.getElementById('overallCategory').value = rowData.Category;

  let codeTable = document.getElementById('op-code-body').querySelectorAll('.op-code-row');

  for (let code of codeTable) {
    code.classList.remove('hidden')
  }

  // Sparse/missing customer or boat records must not block adding an op —
  // fall back to the job's own name fields and leave boat fields blank.
  const customerData = (await shell.getCustomerRecord(rowData.Customer_ID).catch(() => null)) || {};
  const boatData = customerData.Boats?.[rowData.Boat_ID] || {};

  let customerName;

  if(!customerData.First_Name && !customerData.Last_Name){
    customerName = rowData.Customer_Name || '';
  }else if(customerData.Last_Name){
    customerName = customerData.Last_Name + ', ' + customerData.First_Name;
  }else{
    customerName = customerData.First_Name;
  };

  document.getElementById('work-order-form-customer-name').value = customerName;

  document.getElementById('work-order-form-customer-id').value = customerData.Customer_ID || rowData.Customer_ID || '';
  document.getElementById('work-order-form-customer-DMid').value = customerData.DM_Customer || '';



  if (boatData.Boat_Name != null) {
    document.getElementById('work-order-form-boat-name').value = boatData.Boat_Name;
    document.getElementById('work-order-form-boat-id').value = boatData.Boat_ID;
    document.getElementById('work-order-form-boat-DMid').value = boatData.DM_Boat;
    document.getElementById('work-order-form-boat-mooring-number-slip').value = boatData.Mooring_Number || '';
    document.getElementById('work-order-form-boat-length').value = boatData.Boat_Length;
    document.getElementById('work-order-form-boat-beam').value = boatData.Boat_Beam;
    document.getElementById('work-order-form-boat-combo').value = boatData.Combo_Key;
    document.getElementById('work-order-form-boat-mooring-tag').value = boatData.Tag_Number;
    document.getElementById('work-order-form-boat-mooring-weight').value = boatData.Mooring_Weight;
    document.getElementById('work-order-form-boat-bottom-color').value = boatData.Bottom_Paint_Color;
    document.getElementById('work-order-form-boat-bottom-paint').value = boatData.Bottom_Paint_Type;
    document.getElementById('work-order-form-boat-mast-length').value = boatData.Mast_Length;
    document.getElementById('work-order-form-boat-engine-count').value = boatData.Number_of_Engines;
    document.getElementById('work-order-form-boat-battery-count').value = boatData.Number_of_Batteries;
    document.getElementById('work-order-form-boat-engine-type').value = boatData.Engine_Type;
    document.getElementById('work-order-form-boat-boat-type').value = boatData.Boat_Type;

  };

  document.getElementById('work-order-form-customer-email').value = customerData.Email;
  document.getElementById('work-order-form-customer-phone').value = customerData.Phone;
  document.getElementById('work-order-form-customer-street').value = customerData.Street;
  document.getElementById('work-order-form-customer-city').value = customerData.City;
  document.getElementById('work-order-form-customer-state').value = customerData.State;
  document.getElementById('work-order-form-customer-zip').value = customerData.Zip;

  document.getElementById('winterWorkOrder').value = rowData.Work_Order;
  document.getElementById('springWorkOrder').value = rowData.Work_Order;
  document.getElementById('generalWorkOrder').value = rowData.Work_Order;
  document.getElementById('shortDesc').value = rowData.Short_Description;

  let field = document.createElement('fieldset');
  field.id = workOrderNumber.toString();
  let legend = document.createElement('legend');
  legend.innerHTML = workOrderNumber.toString();
  field.appendChild(legend);
  document.getElementById('activeJobs').appendChild(field);


  document.getElementById('work-order-form-dates-launch-date').value = boatData.Launch_Date;
  document.getElementById('work-order-form-dates-haul-date').value = boatData.Haul_Date;

  shell.addOpen("add")
}

// New Add Operation modal — appends an operation to an EXISTING work order.
// Deliberately does not reuse #Add/#opCodeTable/#job (the "create a new work
// order" flow and duplicateOperation() (opPanel.js) still use those
// unchanged) — those are three stacked full-screen modals showing a whole
// work-order-creation UI (customer/boat editors, WO-number card) for what
// should just be "pick a code, fill in a few fields, add it". Reuses the
// op-code catalog (processOpCodes(), parameterized to render into this
// modal's own containers) and the submission pipeline (addJob(), driven
// headlessly the same way addContractServiceOp() already does) rather than
// duplicating either. Renders as a two-pane layout: the WO's current
// operations on the left, the op-code list + Operation Info together on the
// right — no nested overlay.
let addOpCurrentWorkOrder = null;
let addOpSelectedCode = null;
let addOpDataArray = null; // cached opCodeData snapshot, reused to re-filter the picker after each add

// OpCodes already on a WO (excluding Declined, same rule renderAddOpRunningList() uses) — the
// Add-Operation picker excludes these so the same op can't be added twice from this modal.
function getWoOpCodesInUse(workOrderNumber) {
  const ops = (shell.jobsByWorkOrder && shell.jobsByWorkOrder.get(workOrderNumber)) || [];
  return new Set(ops.filter(op => op.Status !== 'Declined').map(op => String(op.OpCode)));
}

function renderAddOpPickerList() {
  if (!addOpDataArray) return;
  processOpCodes(addOpDataArray, {
    tableDiv: document.getElementById('add-op-table-div'),
    codeBody: document.getElementById('add-op-code-body'),
    chipRow: document.getElementById('add-op-type-chips'),
    searchInput: document.getElementById('add-op-code-search'),
    resultCountEl: document.getElementById('add-op-result-count'),
    category: addOpCategoryForPicker,
    excludeOpCodes: getWoOpCodesInUse(addOpCurrentWorkOrder),
  });
}
let addOpCategoryForPicker = undefined;

const addOpAssist = mountScheduleAssist({
  box: document.getElementById('add-op-schedule-assist'),
  getDraft: () => ({
    category: addOpSelectedCode ? (document.getElementById('overallCategory')?.value || addOpSelectedCode.category || '') : '',
    hours: document.getElementById('add-op-est-hours').value,
    begin: document.getElementById('add-op-begin-date').value,
    opType: addOpSelectedCode?.opType || '',
    description: addOpSelectedCode?.description || '',
    shortDesc: document.getElementById('add-op-short-desc').value,
  }),
});
document.getElementById('add-op-est-hours').addEventListener('input', addOpAssist.refreshSoon);
document.getElementById('add-op-begin-date').addEventListener('change', addOpAssist.refreshSoon);

export async function openAddOperationModal() {
  const firstRow = document.getElementById('operations-table')?.querySelector('.op-table-data-row');
  if (!firstRow) return;
  const rowData = JSON.parse(firstRow.getAttribute('data-jobInfo'));
  const workOrderNumber = rowData.Work_Order;
  addOpCurrentWorkOrder = workOrderNumber;

  const customerData = await shell.getCustomerRecord(rowData.Customer_ID);
  const boatData = customerData?.Boats?.[rowData.Boat_ID];

  const customerName = customerData?.Last_Name && customerData?.First_Name
    ? `${customerData.Last_Name}, ${customerData.First_Name}`
    : (customerData?.Last_Name || customerData?.First_Name || '');

  // Headless population of the same hidden fields addJob()/processOpCodes()
  // already read — same fields addOperation() above sets, minus everything
  // that only matters for the WO-creation UI (dates/WO-number/etc. this
  // modal never shows).
  document.getElementById('work-order-form-customer-id').value = customerData?.Customer_ID || '';
  document.getElementById('work-order-form-customer-name').value = customerName;
  document.getElementById('work-order-form-customer-DMid').value = customerData?.DM_Customer || '';
  document.getElementById('work-order-form-customer-email').value = customerData?.Email || '';
  if (boatData) {
    document.getElementById('work-order-form-boat-name').value = boatData.Boat_Name || '';
    document.getElementById('work-order-form-boat-id').value = boatData.Boat_ID || '';
    document.getElementById('work-order-form-boat-DMid').value = boatData.DM_Boat || '';
    document.getElementById('work-order-form-boat-length').value = boatData.Boat_Length || '';
    document.getElementById('work-order-form-boat-beam').value = boatData.Boat_Beam || '';
    document.getElementById('work-order-form-boat-mooring-number-slip').value = boatData.Mooring_Number || '';
    document.getElementById('work-order-form-boat-mooring-weight').value = boatData.Mooring_Weight || '';
    document.getElementById('work-order-form-boat-boat-type').value = boatData.Boat_Type || '';
    document.getElementById('work-order-form-boat-engine-type').value = boatData.Engine_Type || '';
    document.getElementById('work-order-form-boat-engine-count').value = boatData.Number_of_Engines || '';
    document.getElementById('work-order-form-boat-battery-count').value = boatData.Number_of_Batteries || '';
  }

  document.getElementById('add-op-wo-number').textContent = woLabel(workOrderNumber);
  document.getElementById('add-op-context').textContent =
    [(boatData?.Boat_Name || rowData.Boat_Name || ''), customerName].filter(Boolean).join(' · ');

  renderAddOpRunningList();
  resetAddOpForm();

  const db = await getDB();
  addOpDataArray = await new Promise((resolve, reject) => {
    const req = db.transaction(['opCodeData'], 'readonly').objectStore('opCodeData').getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = (e) => reject(e.target.errorCode);
  });
  addOpCategoryForPicker = rowData.Category;

  renderAddOpPickerList();
  bindAddOpCodeClickDelegationOnce();

  document.getElementById('add-op-modal')?.classList.remove('hidden');
}

function renderAddOpRunningList() {
  const container = document.getElementById('add-op-running-list');
  if (!container) return;
  const ops = ((shell.jobsByWorkOrder && shell.jobsByWorkOrder.get(addOpCurrentWorkOrder)) || [])
    .filter(op => op.Status !== 'Declined');

  if (!ops.length) {
    container.innerHTML = '<div class="add-op-running-empty">No operations yet.</div>';
    return;
  }

  container.innerHTML = '';
  ops.forEach((op) => {
    const severity = operationSeverity(op, shell.latestReceivingData);
    const shortDesc = (op.Short_Description_DM || op.Description || '').split(':')[0];
    const row = document.createElement('div');
    row.className = 'add-op-running-row';
    row.innerHTML = `
      <span class="add-op-running-opcode">${escapeHTML(op.OpCode || '')}</span>
      <span class="add-op-running-desc">${escapeHTML(shortDesc)}</span>
      <span class="status-info-p wo-tone-${OP_ROW_PILL_TONE[severity] || 'slate'}">${escapeHTML(OP_ROW_PILL_LABEL[severity] || op.Status || '')}</span>
    `;
    container.appendChild(row);
  });
}

// Own delegated click handler on this modal's op-code list — deliberately
// not opCodeClicked(), which always opens the legacy #job overlay
// (document.getElementById('job').style.display = 'flex'), exactly what
// this modal exists to avoid stacking on top of.
function bindAddOpCodeClickDelegationOnce() {
  const container = document.getElementById('add-op-code-body');
  if (!container || container.dataset.opClickBound === '1') return;
  container.dataset.opClickBound = '1';
  container.addEventListener('click', (e) => {
    const row = e.target.closest('.op-code-row');
    if (row) selectAddOpCode(row);
  });
}

function selectAddOpCode(row) {
  let data;
  try { data = JSON.parse(row.getAttribute('data-opcode') || '{}'); } catch { data = {}; }
  addOpSelectedCode = data;

  const desc = String(data.description || '');
  const lowerDesc = desc.toLowerCase();

  document.getElementById('add-op-info-opcode').textContent = data.opCode || '';
  document.getElementById('add-op-info-name').textContent = desc.split(':')[0] || '';
  document.getElementById('add-op-category-display').value = data.category || '';
  document.getElementById('add-op-type-display').value = data.opType || '';
  document.getElementById('add-op-est-hours').value = data.hours || '';
  document.getElementById('add-op-begin-date').value = '';
  document.getElementById('add-op-status').value = 'On Work Schedule';

  const shortDescEl = document.getElementById('add-op-short-desc');
  if (desc.includes(':')) {
    shortDescEl.value = desc.split(':')[0];
  } else if (lowerDesc.includes('shrinkwrap boat')) {
    shortDescEl.value = 'Shrinkwrap Boat';
  } else {
    shortDescEl.value = '';
  }

  // Same conditional "extra fields" opCodeClicked() shows in the legacy
  // #job panel (mooring #/weight, bottom-paint coats, discount) — own
  // fields/ids here rather than reusing #opMooringNumber etc., which live
  // inside #job and are wired to that panel's own listeners.
  const showsMooring = lowerDesc.includes('mooring');
  document.getElementById('add-op-mooring-number-field').classList.toggle('hidden', !showsMooring);
  document.getElementById('add-op-mooring-weight-field').classList.toggle('hidden', !showsMooring);
  if (showsMooring) {
    document.getElementById('add-op-mooring-number').value = document.getElementById('work-order-form-boat-mooring-number-slip')?.value || '';
    document.getElementById('add-op-mooring-weight').value = document.getElementById('work-order-form-boat-mooring-weight')?.value || '';
  }

  const showsCoats = lowerDesc.includes('bottom paint') && !lowerDesc.includes('storage');
  document.getElementById('add-op-coats-field').classList.toggle('hidden', !showsCoats);
  if (showsCoats) document.getElementById('add-op-coats-count').value = '2';

  const showsDiscount = (data.opCode || '') === 'DISCNT';
  document.getElementById('add-op-discount-field').classList.toggle('hidden', !showsDiscount);
  if (showsDiscount) document.getElementById('add-op-discount-info').value = '';

  // Collapse the code list once a code is picked — otherwise the info form
  // (and its submit button) got squeezed below a long, still-fully-visible
  // results list and needed scrolling to reach. "Change code" swaps it back.
  document.getElementById('add-op-picker-body-row')?.classList.add('hidden');
  document.getElementById('add-op-code-search')?.classList.add('hidden');
  document.getElementById('add-op-result-count')?.classList.add('hidden');
  document.getElementById('add-op-change-code')?.classList.remove('hidden');
  document.getElementById('add-op-info-form').classList.remove('hidden');

  addOpAssist.reset();
  addOpAssist.refresh();
}

// Local equivalent of rebuildOpDescription() (app.js, further down), which
// is wired to #description/#opMooringNumber/etc. inside the legacy #job
// panel — this modal has its own fields, and this only needs to run once at
// submit time rather than live on every keystroke, so it isn't worth
// threading another target-bundle through the original. One intentional
// simplification vs. the original: the multi-mooring (comma-separated
// mooring list) special case falls back to the plain single-mooring format
// here instead of calling updateDescription() — an edge case, not the
// common path.
function buildAddOpDescription() {
  const data = addOpSelectedCode;
  if (!data) return '';
  const desc = String(data.description || '');
  const lowerDesc = desc.toLowerCase();
  const nowYear = new Date().getFullYear();
  const mooring = document.getElementById('add-op-mooring-number')?.value || '';
  const mooringWeight = document.getElementById('add-op-mooring-weight')?.value || '';

  if (lowerDesc.includes('bottom paint') && lowerDesc.includes('storage')) {
    return desc;
  } else if (lowerDesc.includes('bottom paint') && !lowerDesc.includes('storage')) {
    const coats = parseInt(document.getElementById('add-op-coats-count')?.value, 10);
    if (!isNaN(coats) && coats > 0) {
      const numbers = { 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten' };
      const word = numbers[coats] || String(coats);
      return desc + ' Paint boat with ' + word + ' (' + String(coats) + ') coat of anti-fouling paint.';
    }
    return desc;
  } else if ((data.opCode || '') === 'DISCNT') {
    return 'Discount: ' + (document.getElementById('add-op-discount-info')?.value || '');
  } else if (lowerDesc.includes('remove batter') || lowerDesc.includes('install batter')) {
    const battCount = document.getElementById('work-order-form-boat-battery-count')?.value || '';
    return desc + (battCount === '' ? ' BATTERY COUNT IS UNKNOWN' : ` BATTERY COUNT (${battCount})`);
  } else if (
    lowerDesc.includes('general rigging labor') ||
    lowerDesc.includes('general mechanical labor') ||
    lowerDesc.includes('general boat maintenance')
  ) {
    return '';
  } else if (lowerDesc.includes('mooring') && !lowerDesc.includes('haul mooring') && !lowerDesc.includes('mooring placement')) {
    return desc + ' (MOORING: ' + mooring + ')';
  } else if (lowerDesc.includes('haul mooring')) {
    return 'HAUL MOORING ' + mooring + ' ' + nowYear + ' SEASON. ' + mooringWeight + ' @ $0.70 PER LB.';
  } else if (lowerDesc.includes('mooring placement')) {
    return 'PLACE MOORING ' + mooring + ' ' + nowYear + ' SEASON. ' + mooringWeight + ' LBS @ $0.70 PER LB.';
  }
  return desc;
}

function resetAddOpForm() {
  addOpSelectedCode = null;
  document.getElementById('add-op-info-form')?.classList.add('hidden');
  document.getElementById('add-op-picker-body-row')?.classList.remove('hidden');
  document.getElementById('add-op-code-search')?.classList.remove('hidden');
  document.getElementById('add-op-result-count')?.classList.remove('hidden');
  document.getElementById('add-op-change-code')?.classList.add('hidden');
  const searchInput = document.getElementById('add-op-code-search');
  if (searchInput) searchInput.value = '';
  const codeBody = document.getElementById('add-op-code-body');
  if (codeBody) codeSearch(searchInput, codeBody, document.getElementById('add-op-result-count'));
}

function closeAddOperationModal() {
  document.getElementById('add-op-modal')?.classList.add('hidden');
  addOpCurrentWorkOrder = null;
  addOpSelectedCode = null;
  addOpDataArray = null;
  addOpCategoryForPicker = undefined;
}

document.getElementById('add-op-close')?.addEventListener('click', closeAddOperationModal);
document.getElementById('add-op-done')?.addEventListener('click', closeAddOperationModal);
document.getElementById('add-op-cancel-selection')?.addEventListener('click', resetAddOpForm);
document.getElementById('add-op-change-code')?.addEventListener('click', resetAddOpForm);
document.getElementById('add-op-modal')?.addEventListener('click', (e) => {
  if (e.target.id === 'add-op-modal') closeAddOperationModal();
});
document.getElementById('add-op-code-search')?.addEventListener('input', () => {
  codeSearch(document.getElementById('add-op-code-search'), document.getElementById('add-op-code-body'), document.getElementById('add-op-result-count'));
});
document.getElementById('add-op-coats-minus')?.addEventListener('click', () => {
  const el = document.getElementById('add-op-coats-count');
  el.value = Math.max(1, (parseInt(el.value, 10) || 1) - 1);
});
document.getElementById('add-op-coats-plus')?.addEventListener('click', () => {
  const el = document.getElementById('add-op-coats-count');
  el.value = Math.min(10, (parseInt(el.value, 10) || 0) + 1);
});

document.getElementById('add-op-submit')?.addEventListener('click', async () => {
  if (!addOpSelectedCode || !addOpCurrentWorkOrder) return;
  const submitBtn = document.getElementById('add-op-submit');
  submitBtn.disabled = true;
  try {
    // Headless population of the same #job-panel-owned hidden fields
    // addJob() reads (see addContractServiceOp() above for the established
    // precedent of driving addJob() this way).
    document.getElementById('opCode').value = addOpSelectedCode.opCode || '';
    document.getElementById('opWeight').value = '';
    document.getElementById('opType').value = addOpSelectedCode.opType || '';
    document.getElementById('category').value = addOpSelectedCode.category || '';
    document.getElementById('dmShortDesc').value = document.getElementById('add-op-short-desc').value;
    document.getElementById('description').value = buildAddOpDescription();
    document.getElementById('estimatedHours').value = document.getElementById('add-op-est-hours').value;
    document.getElementById('estimatedCharge').value = '';
    document.getElementById('status').value = document.getElementById('add-op-status').value;
    document.getElementById('begin').value = document.getElementById('add-op-begin-date').value;
    document.getElementById('date').value = '';
    document.getElementById('flatPerFoot').value = addOpSelectedCode.flatRatePerFoot || '';
    document.getElementById('flatLabor').value = addOpSelectedCode.flatRateLabor || '';
    document.getElementById('flatMethod').value = '';
    document.getElementById('shortDesc').value = document.getElementById('add-op-short-desc').value;

    setPendingOpSchedule(addOpAssist.selection());
    await addJob(undefined, addOpCurrentWorkOrder);

    renderAddOpRunningList();
    resetAddOpForm();
    renderAddOpPickerList(); // re-excludes the code just added, on top of resetAddOpForm()'s search-only refresh

    // The WO row's own expanded Operations panel (displayOperations()) is
    // built once when opened and isn't told about adds happening in this
    // modal on top of it — without this, its "X hrs logged · Y of Z done"
    // header and table stay at the pre-add count until the page reloads,
    // even though the WO card's own summary above it updates live.
    if (shell.activeRow && shell.activeRow.isConnected && shell.globalWorkOrder === addOpCurrentWorkOrder) {
      const anchorRow = shell.activeRow;
      shell.removeOperationDetails(anchorRow);
      shell.activeRow = anchorRow; // removeOperationDetails() clears it; the row is still the open one
      shell.displayOperations(shell.globalWorkOrder, anchorRow);
    }
  } finally {
    setPendingOpSchedule(null);
    submitBtn.disabled = false;
  }
});
